import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAvatar,{attrs:{"size":_vm.size_val}},[(_vm.val)?_c(VImg,{attrs:{"src":_vm.getImg(_vm.val)}}):_c(VIcon,{attrs:{"size":_vm.size_val}},[_vm._v(" mdi-"+_vm._s(_vm.icon_val)+" ")])],1),(_vm.lab_prop)?_c('span',{staticClass:"ml-2 caption",domProps:{"textContent":_vm._s(_vm.lab)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }